<script lang="ts" setup>
import { useAppUpdate } from "@/stores/appUpdate";
import { storeToRefs } from "pinia";

const appUpdateStore = useAppUpdate();
const { needRefresh } = storeToRefs(appUpdateStore);

async function close() {
  needRefresh.value = false;
}
</script>

<template>
  <div v-if="needRefresh" class="pwa-toast bg-base-100 flex gap-2 flex-col">
    <div class="flex gap-2 items-center">
      <i-shape-icon />
      <span>
        {{ $t("ReloadPrompt.hasUpdate") }}
      </span>
    </div>
    <div class="flex gap-2">
      <button
        v-if="needRefresh"
        class="btn btn-xs btn-primary"
        @click="appUpdateStore.confirmUpdate()"
      >
        <check-outline-icon class="icon-sm" />
        {{ $t("ReloadPrompt.reload") }}
      </button>
      <button class="btn btn-xs" @click="close">
        {{ $t("ReloadPrompt.later") }}
      </button>
    </div>
  </div>
</template>

<style>
.pwa-toast {
  position: fixed;
  right: 130px;
  bottom: 60px;
  margin: 16px;
  padding: 12px;
  border: 1px solid #8885;
  border-radius: 4px;
  z-index: 1;
  text-align: left;
}
</style>
